import { PlatformType } from '@/types/bff/gql-schema';

const convertPlatform = (platform?: PlatformType) => {
  switch (platform) {
    case PlatformType.Android:
      return 'Android';
    case PlatformType.Ios:
      return 'iOS';
    case PlatformType.Web:
      return 'Web';
    default:
      return 'Unknown';
  }
};

export { convertPlatform };
